// Deterministic colour assignment for box types.
// Stable across renders: same id → same hex.
// Palette tuned for the soft light background (#F6F5F1).
// Picked to be mutually distinguishable and at least ~3:1 against bg.

export const SWATCH_PALETTE = [
    "#22C55E", // green
    "#3B82F6", // azure
    "#E8890C", // amber (accent)
    "#EC4899", // pink
    "#8B5CF6", // violet
    "#10B981", // emerald
    "#F97316", // orange
    "#0891B2", // cyan
    "#CA8A04", // yellow
    "#F43F5E", // rose
    "#65A30D", // lime
    "#A855F7", // purple
];

function hash(str) {
    let h = 5381;
    const s = String(str ?? "");
    for (let i = 0; i < s.length; i++) {
        h = (h * 33) ^ s.charCodeAt(i);
    }
    return h >>> 0;
}

export function colorByBoxId(boxId) {
    if (!boxId) return SWATCH_PALETTE[0];
    return SWATCH_PALETTE[hash(boxId) % SWATCH_PALETTE.length];
}
